// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkSelectorUpload-cls1_kdL","cls2":"WorkSelectorUpload-cls2_KgP WorkSelectorUpload-cls1_kdL"};